var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_subscriptions",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1707",
    "data-name": "Rectangle 1707",
    width: 18.9,
    height: 23.625,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1684",
    "data-name": "Rectangle 1684",
    width: 42,
    height: 42,
    fill: "#6639b7",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_subscriptions-2",
    "data-name": "icon_subscriptions",
    transform: "translate(11.813 9.188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3779",
    "data-name": "Groupe 3779",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13578",
    "data-name": "Trac\\xE9 13578",
    d: "M9.45.592A.591.591,0,0,0,8.859,0H4.725A4.725,4.725,0,0,0,0,4.726V18.9a4.725,4.725,0,0,0,4.725,4.725h9.45A4.725,4.725,0,0,0,18.9,18.9V10.042a.591.591,0,0,0-.591-.591H15.356A5.906,5.906,0,0,1,9.45,3.545Zm8.528,6.5a.5.5,0,0,0,.486-.724,3.544,3.544,0,0,0-.6-.8L13.34,1.039a3.542,3.542,0,0,0-.8-.6.5.5,0,0,0-.724.486V3.545a3.544,3.544,0,0,0,3.544,3.544ZM5.906,8.27a1.181,1.181,0,0,0,0,2.363H7.087a1.181,1.181,0,0,0,0-2.363ZM4.725,14.176a1.181,1.181,0,0,1,1.181-1.181h7.087a1.181,1.181,0,1,1,0,2.363H5.906a1.181,1.181,0,0,1-1.181-1.181m0,4.725A1.181,1.181,0,0,1,5.906,17.72h7.087a1.181,1.181,0,1,1,0,2.362H5.906A1.181,1.181,0,0,1,4.725,18.9",
    transform: "translate(0 -0.001)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSubscriptions);
export default __webpack_public_path__ + "static/media/icon_subscriptions.8d4ce7908fcfc51193756c5b45bd9aa5.svg";
export { ForwardRef as ReactComponent };